<template>
    <div>
        <label
            class="w-full flex items-center font-medium text-gray-700 cursor-pointer mb-2 border border-gray-200 p-4"
            :class="{
                'bg-primary-light': item.id == method,
            }"
            v-for="item in methods"
        >
            <input
                class="rounded-full border-gray-300 text-primary shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                type="radio"
                name="payment_method"
                :checked="item.id == method"
                :value="item.id"
                @change="$emit('update:method', $event.target.value)"
            >
            <div class="flex-grow flex justify-between items-center ml-2 text-gray-600">
                <span>{{ item.name }}</span>
                <img :src="item.img" class="h-5" />
            </div>
        </label>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            method: {
                type: [String],
                default: null,
            },
        },
        data() {
            return {
                methods: this.fetchMethods(),
            };
        },
        methods: {
            fetchMethods() {

                var methods = [];
                var paymentMethods = this.$page.props.__site.payment_methods;

                if (paymentMethods.includes('card')) {
                    methods.push({
                        id: 'card',
                        name: this.__('home::checkout.payment_method_card'),
                        img: '/media/payment-cards.png',
                    });
                }

                if (paymentMethods.includes('mobilepay')) {
                    methods.push({
                        id: 'mobilepay',
                        name: this.__('home::checkout.payment_method_mobilepay'),
                        img: '/media/payment-mobilepay.png',
                    });
                }

                if (paymentMethods.includes('vipps')) {
                    methods.push({
                        id: 'vipps',
                        name: this.__('home::checkout.payment_method_vipps'),
                        img: '/media/payment-vipps.png',
                    });
                }

                return methods;

            },
        },
    }
</script>
